<template>
  <div class="login_container">
    <div class="login_box">
      <div class="login_head">
        <h2>{{System_Name}}</h2>
      </div>

      <!-- 登录表单 -->
      <div class="login_body">
        <h2>登录</h2>
        <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" label-width="0px">

          <el-form-item label="" prop="username">
            <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
          </el-form-item>

          <el-form-item label="" prop="password">
            <el-input type="password" v-model="loginForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码"></el-input>
          </el-form-item>

          <el-form-item>
            <button type='button' class="login_btn" @click="submitForm()">登录</button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      System_Name: '',
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          },
          {
            min: 4,
            max: 20,
            message: '长度在 4 到 20 个字符',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 4,
            max: 20,
            message: '长度在 4 到 20 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.System_Name = Vue.prototype.global.System_Name
    this.CheckLoginStatus()
  },
  methods: {
    submitForm () {
      var that = this
      that.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.Login()
        }
      })
    },
    Login: function () {
      var that = this
      var data = {
        userLogin: that.loginForm.username,
        userPassword: that.loginForm.password
      }
      axios.post(Vue.prototype.global.Url_login, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            // 保存数据
            localStorage.setItem('tempUuid', response.data.data.tempUuid)
            localStorage.setItem('userName', response.data.data.userName)
            localStorage.setItem('userAvatar', response.data.data.userAvatar)
            localStorage.setItem('authToken', response.data.data.authToken)
            localStorage.setItem('organizationType', response.data.data.organizationType)
            localStorage.setItem('organizationId', response.data.data.organizationId)
            localStorage.setItem('aptustwoGvListActionType', JSON.stringify(response.data.data.aptustwoGvListActionType))
            localStorage.setItem('aptustwoGvListBodyType', JSON.stringify(response.data.data.aptustwoGvListBodyType))
            localStorage.setItem('aptustwoGvListMuscleRoup', JSON.stringify(response.data.data.aptustwoGvListMuscleRoup))
            localStorage.setItem('aptustwoGvListAccessories', JSON.stringify(response.data.data.aptustwoGvListAccessories))
            localStorage.setItem('aptustwoGvListUseLocation', JSON.stringify(response.data.data.aptustwoGvListUseLocation))
            localStorage.setItem('aptustwoGvListCourseType', JSON.stringify(response.data.data.aptustwoGvListCourseType))
            localStorage.setItem('aptustwoGvListCourseDifficulty', JSON.stringify(response.data.data.aptustwoGvListCourseDifficulty))
            localStorage.setItem('aptustwoGvListCourseTimeType', JSON.stringify(response.data.data.aptustwoGvListCourseTimeType))
            localStorage.setItem('aptustwoGvListTrainPlanClassification', JSON.stringify(response.data.data.aptustwoGvListTrainPlanClassification))
            localStorage.setItem('aptustwoGvListTrainPlanType', JSON.stringify(response.data.data.aptustwoGvListTrainPlanType))
            localStorage.setItem('gvTypeList', response.data.data.gvTypeList)
            // 跳转
            that.$router.push('/HomePage')
          }
        })
        .catch(function (error) {
          Vue.prototype.FunRemindNetWorkError(error)
        })
    },
    CheckLoginStatus: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_checkLoginStatus, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.$router.push('/Home')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login_container {
  position: relative;
  height: 100%;
  background: url(../assets/images/loginbg.png) no-repeat;
  background-size: 100% 100%;

  .login_box {
    position: fixed;
    top: 24%;
    left: 50%;
    transform: translate(-50%, -24%);

    .login_head {
      text-align: center;
      h2{
        font-weight: bold;
        font-size: 32px;
        margin-top: 12px;
        color: #4085da;
      }
      small{
        display: block;
        font-size: 24px;
        margin-top: 15px;
        color: #cad4e1;
      }
    }
  }
}

.login_body {
  width: 450px;
  padding: 40px 50px 70px 50px;
  margin-top: 70px;
  margin-left: 45px;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 16px 0 rgb(187 208 230 / 40%);

  h2{
    text-align: center;
    color: #4085da;
    font-weight: normal;
    font-size: 24px;
  }
}

.login_btns {
  display: flex;
  justify-content: space-between;
}

.login_foot{
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, -40px);
  text-align: center;
  color: #fff;
}

.el-form {
  width: 100%;
  margin-top: 30px;
  box-sizing: border-box;
  padding: 0 30px 0 20px;
}

.el-button {
  width: 100%;
}

@media ( max-width: 1440px) {
  .login_body {
    width: 450px;
    padding: 40px 50px 40px 50px;
    margin-top: 40px;
  }

  .login_foot{
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, -40px);
    text-align: center;
    color: #fff;
  }
}

</style>
